export default "__VITE_ASSET__0049921e__"